// Каталог сервисов платформы для страницы /admin/services/.
// %-готовности — экспертная оценка зрелости сервиса по критериям:
//   - наличие фронт-страницы
//   - подключение к бэк-эндпоинту
//   - локализация (ru/en/ky)
//   - доступность (a11y)
//   - покрытие основных сценариев из инструкции
//   - dark/light темы
//
// Раздел `roles` — список кодов ролей, которым сервис доступен (можно как
// отображать в плитке, так и фильтровать).
//
// Категории помогают группировать в UI.

export const SERVICE_CATEGORIES = {
  ACADEMIC: { key: 'academic', label: 'Учебный процесс', color: '#3b82f6' },
  STUDENTS: { key: 'students', label: 'Студенты', color: '#10b981' },
  EMPLOYEES: { key: 'employees', label: 'Сотрудники', color: '#8b5cf6' },
  ADMIN: { key: 'admin', label: 'Администрирование', color: '#f59e0b' },
  FINANCE: { key: 'finance', label: 'Финансы', color: '#ef4444' },
  ARCHIVE: { key: 'archive', label: 'Архив и документы', color: '#64748b' },
  EXTRA: { key: 'extra', label: 'Дополнительные', color: '#14b8a6' },
  COMMUNICATION: { key: 'communication', label: 'Коммуникации', color: '#ec4899' },
}

export const SERVICES = [
  // === Учебный процесс ===
  {
    id: 'schedule',
    title: 'Расписание',
    description: 'Сетка пар, конструктор, импорт из XLSX, перенос занятий',
    category: 'academic',
    path: '/schedule/',
    icon: 'schedule',
    completion: 88,
    roles: ['student', 'teacher', 'curator', 'head_of_department', 'dean', 'methodist', 'parent', 'foreign_student', 'postgrad', 'dpo_student'],
  },
  {
    id: 'syllabus',
    title: 'Учебные планы',
    description: 'Конструктор ОПОП, версии, согласование, утверждение деканом',
    category: 'academic',
    path: '/syllabuses/',
    icon: 'syllabus',
    completion: 92,
    roles: ['methodist', 'dean', 'head_of_department', 'rectorate', 'sysadmin'],
  },
  {
    id: 'journal',
    title: 'Журнал и оценки',
    description: 'Посещаемость, оценки 1-4, оправдательные документы',
    category: 'academic',
    path: '/journal/',
    icon: 'journal',
    completion: 85,
    roles: ['teacher', 'curator', 'head_of_department', 'dean', 'methodist', 'student'],
  },
  {
    id: 'tests',
    title: 'Тесты и работы',
    description: 'Конструктор тестов, банк вопросов, прокторинг, авто-проверка',
    category: 'academic',
    path: '/tests/',
    icon: 'test',
    completion: 80,
    roles: ['student', 'teacher', 'methodist', 'head_of_department', 'sysadmin'],
  },
  {
    id: 'surveys',
    title: 'Анкеты и опросы',
    description: 'Анкетирование студентов, обратная связь, отчёты',
    category: 'academic',
    path: '/surveys/',
    icon: 'list',
    completion: 70,
    roles: ['student', 'teacher', 'methodist', 'rectorate', 'sysadmin'],
  },
  {
    id: 'assignments',
    title: 'Задания',
    description: 'Выдача заданий, приём решений, проверка, оценка',
    category: 'academic',
    path: '/assignments-list/',
    icon: 'assignment',
    completion: 78,
    roles: ['student', 'teacher', 'curator', 'head_of_department', 'dean', 'methodist'],
  },
  {
    id: 'gradebook',
    title: 'Зачётка',
    description: 'Сводная ведомость оценок, GPA, история сессий',
    category: 'academic',
    path: '/gradebook/',
    icon: 'gradebook',
    completion: 86,
    roles: ['student', 'parent', 'teacher', 'curator', 'head_of_department', 'dean', 'methodist'],
  },
  {
    id: 'statements',
    title: 'Ведомости преподавателя',
    description: 'Формирование, подписание ПИН-кодом, отправка декану',
    category: 'academic',
    path: '/teacher-statements/',
    icon: 'file-text',
    completion: 82,
    roles: ['teacher', 'methodist', 'dean', 'head_of_department'],
  },
  {
    id: 'sessions',
    title: 'Сессии и пересдачи',
    description: 'Расписание сессий, ведомости пересдач, ректорские',
    category: 'academic',
    path: '/sessions/',
    icon: 'exam',
    completion: 72,
    roles: ['methodist', 'dean', 'head_of_department', 'rectorate', 'sysadmin'],
  },
  {
    id: 'plagiarism',
    title: 'Плагиат',
    description: 'Антиплагиат для ВКР, курсовых, ДЗ. Отчёт PDF.',
    category: 'academic',
    path: '/plagiarism/',
    icon: 'check-double',
    completion: 65,
    roles: ['teacher', 'methodist', 'dean', 'rectorate', 'sysadmin'],
  },
  {
    id: 'distance',
    title: 'Дистанционное обучение',
    description: 'Видеолекции, виртуальные классы (Zoom/Teams/Jitsi)',
    category: 'academic',
    path: '/distance/',
    icon: 'video',
    completion: 60,
    roles: ['student', 'teacher', 'methodist', 'dean', 'foreign_student', 'postgrad', 'dpo_student'],
  },
  {
    id: 'practice',
    title: 'Практика',
    description: 'Организации, направления на практику, отчёты, оценки',
    category: 'academic',
    path: '/practice/',
    icon: 'briefcase',
    completion: 75,
    roles: ['student', 'teacher', 'methodist', 'dean', 'head_of_department'],
  },
  {
    id: 'diploma',
    title: 'ВКР',
    description: 'Темы, версии, антиплагиат, защита, оценка',
    category: 'academic',
    path: '/diploma/',
    icon: 'graduation',
    completion: 78,
    roles: ['student', 'teacher', 'methodist', 'dean', 'head_of_department'],
  },

  // === Студенты ===
  {
    id: 'students-list',
    title: 'Реестр студентов',
    description: 'Поиск, фильтры, история статусов, документы',
    category: 'students',
    path: '/students-list/',
    icon: 'users',
    completion: 90,
    roles: ['hr_students', 'methodist', 'dean', 'head_of_department', 'rectorate', 'sysadmin'],
  },
  {
    id: 'admission',
    title: 'Приёмная кампания',
    description: 'Зачисление абитуриентов (мастер из 4 шагов)',
    category: 'students',
    path: '/admission/',
    icon: 'user-plus',
    completion: 85,
    roles: ['hr_students', 'rectorate', 'sysadmin'],
  },
  {
    id: 'admission-portal',
    title: 'Портал абитуриента',
    description: 'Самоподача документов, выбор направлений, ДВИ',
    category: 'students',
    path: '/admission-portal/',
    icon: 'user-plus',
    completion: 5,
    roles: ['applicant', 'hr_students', 'rectorate', 'sysadmin'],
    note: 'В разработке. Воронка приёмной кампании запланирована.',
  },
  {
    id: 'transfers',
    title: 'Переводы',
    description: 'Между группами, формами, на следующий курс',
    category: 'students',
    path: '/transfers/',
    icon: 'arrow-right',
    completion: 75,
    roles: ['hr_students', 'methodist', 'dean', 'rectorate', 'sysadmin'],
  },
  {
    id: 'student-lifecycle',
    title: 'Жизненный цикл студента',
    description: 'Академ. отпуск, отчисление, восстановление, выпуск',
    category: 'students',
    path: '/student-lifecycle/',
    icon: 'activity',
    completion: 80,
    roles: ['hr_students', 'methodist', 'dean', 'rectorate', 'sysadmin'],
  },
  {
    id: 'foreign-students',
    title: 'Иностранные студенты',
    description: 'Визы, миграционные карты, регистрация',
    category: 'students',
    path: '/foreign-students/',
    icon: 'globe',
    completion: 65,
    roles: ['foreign_student', 'hr_students', 'methodist', 'dean', 'rectorate', 'sysadmin'],
  },
  {
    id: 'military-students',
    title: 'Воинский учёт',
    description: 'Категории годности, отсрочки, военкомат',
    category: 'students',
    path: '/military-students/',
    icon: 'shield',
    completion: 55,
    roles: ['hr_students', 'methodist', 'rectorate', 'sysadmin'],
  },
  {
    id: 'postgrad',
    title: 'Магистратура и аспирантура',
    description: 'Этап, научный руководитель, тема, защита',
    category: 'students',
    path: '/postgrad/',
    icon: 'graduation',
    completion: 70,
    roles: ['postgrad', 'hr_students', 'methodist', 'dean', 'rectorate', 'sysadmin'],
  },
  {
    id: 'dpo',
    title: 'ДПО',
    description: 'Курсы повышения квалификации, сертификаты',
    category: 'students',
    path: '/dpo/',
    icon: 'award',
    completion: 60,
    roles: ['dpo_student', 'hr_students', 'methodist', 'rectorate', 'sysadmin'],
  },
  {
    id: 'student-life',
    title: 'Студенческая жизнь',
    description: 'Спорт, творчество, награды, дисциплина',
    category: 'students',
    path: '/student-life/',
    icon: 'heart',
    completion: 50,
    roles: ['student', 'curator', 'teacher', 'dean', 'hr_students', 'methodist', 'rectorate', 'sysadmin'],
  },
  {
    id: 'career',
    title: 'Карьерный портал',
    description: 'Резюме студента, вакансии, отслеживание выпускников',
    category: 'students',
    path: '/career/',
    icon: 'target',
    completion: 55,
    roles: ['student', 'teacher', 'rectorate', 'sysadmin', 'foreign_student'],
  },
  {
    id: 'curator-drilldown',
    title: 'Детализация по куратору',
    description: 'Глубокий анализ группы (отсев, успеваемость)',
    category: 'students',
    path: '/curator-drilldown/',
    icon: 'activity',
    completion: 75,
    roles: ['curator', 'dean', 'methodist', 'head_of_department', 'rectorate', 'sysadmin'],
  },

  // === Сотрудники ===
  {
    id: 'employees-list',
    title: 'Реестр сотрудников',
    description: 'Карточки, должности, подразделения',
    category: 'employees',
    path: '/employees/',
    icon: 'briefcase',
    completion: 88,
    roles: ['hr_employees', 'rectorate', 'sysadmin', 'dean', 'head_of_department'],
  },
  {
    id: 'employee-wizard',
    title: 'Мастер найма',
    description: 'Приём сотрудника в 4 шага: данные, должность, доступы, финал',
    category: 'employees',
    path: '/employee-wizard/',
    icon: 'user-plus',
    completion: 82,
    roles: ['hr_employees', 'rectorate', 'sysadmin'],
  },
  {
    id: 'employee-card',
    title: 'Карточка сотрудника',
    description: '14 разделов: личное, паспорт, образование, военный, семья, награды и т.п.',
    category: 'employees',
    path: '/employee-card/',
    icon: 'user',
    completion: 80,
    roles: ['hr_employees', 'rectorate', 'sysadmin', 'dean', 'head_of_department'],
  },
  {
    id: 'workload',
    title: 'Нагрузка',
    description: 'Часы преподавателей по семестрам',
    category: 'employees',
    path: '/workload/',
    icon: 'briefcase',
    completion: 60,
    roles: ['teacher', 'head_of_department', 'dean', 'methodist'],
  },
  {
    id: 'science',
    title: 'Наука',
    description: 'Публикации (Scopus/WoS/РИНЦ), гранты, конференции',
    category: 'employees',
    path: '/science/',
    icon: 'flame',
    completion: 50,
    roles: ['teacher', 'head_of_department', 'dean', 'methodist', 'rectorate', 'sysadmin'],
  },
  {
    id: 'structure',
    title: 'Оргструктура',
    description: 'Управления, отделы, должности',
    category: 'employees',
    path: '/structure/',
    icon: 'layers',
    completion: 75,
    roles: ['student', 'teacher', 'curator', 'head_of_department', 'dean', 'methodist', 'hr_students', 'hr_employees', 'accountant', 'archivist', 'rectorate', 'sysadmin'],
  },

  // === Финансы ===
  {
    id: 'accounting',
    title: 'Бухгалтерия',
    description: 'Кассовые ордера, контракты, зарплаты, фонды, отчёты',
    category: 'finance',
    path: '/accounting/',
    icon: 'wallet',
    completion: 85,
    roles: ['accountant', 'rectorate', 'sysadmin'],
  },
  {
    id: 'payment',
    title: 'Оплата (студент)',
    description: 'Договор, начисления, история, квитанция PDF',
    category: 'finance',
    path: '/payment/',
    icon: 'wallet',
    completion: 10,
    roles: ['student', 'parent', 'accountant'],
    note: 'Студенческий раздел оплаты в разработке (см. ошибки_промежутка.md §7).',
  },
  {
    id: 'orders',
    title: 'Приказы',
    description: 'Кадровые и студенческие приказы с подписанием',
    category: 'finance',
    path: '/orders/',
    icon: 'document',
    completion: 78,
    roles: ['hr_students', 'hr_employees', 'methodist', 'dean', 'head_of_department', 'rectorate', 'sysadmin'],
  },

  // === Архив ===
  {
    id: 'archive',
    title: 'Архивная система',
    description: 'Фонды → Описи → Дела → Документы. 3 архива (университет, студенты, сотрудники)',
    category: 'archive',
    path: '/archive/',
    icon: 'archive',
    completion: 80,
    roles: ['archivist', 'rectorate', 'sysadmin', 'hr_students', 'hr_employees', 'dean', 'methodist'],
  },
  {
    id: 'ocr-search',
    title: 'OCR-поиск по архиву',
    description: 'Полнотекстовый поиск по сканам документов',
    category: 'archive',
    path: '/archive/ocr-search/',
    icon: 'search',
    completion: 65,
    roles: ['archivist', 'rectorate', 'sysadmin'],
  },
  {
    id: 'order-link',
    title: 'Связь приказов с архивом',
    description: 'Привязка цифровых приказов к архивным делам',
    category: 'archive',
    path: '/archive/order-link/',
    icon: 'link',
    completion: 60,
    roles: ['archivist', 'rectorate', 'sysadmin'],
  },
  {
    id: 'library',
    title: 'Библиотека',
    description: 'Поиск книг, бронирование, выдача, штрафы',
    category: 'archive',
    path: '/library/',
    icon: 'library',
    completion: 70,
    roles: ['student', 'teacher', 'curator', 'head_of_department', 'dean', 'methodist', 'hr_students', 'hr_employees', 'accountant', 'archivist', 'rectorate', 'sysadmin', 'parent'],
  },
  {
    id: 'dorm',
    title: 'Общежитие',
    description: 'Корпуса, комнаты, заселение, оплата, инциденты',
    category: 'extra',
    path: '/dorm/',
    icon: 'dorm',
    completion: 70,
    roles: ['student', 'foreign_student', 'dorm_staff', 'hr_students', 'accountant', 'rectorate', 'sysadmin'],
  },

  // === Администрирование ===
  {
    id: 'admin-panel',
    title: 'Админ-панель',
    description: 'Дашборд + 12 табов: пользователи, роли, отчёты, настройки',
    category: 'admin',
    path: '/admin/',
    icon: 'cog',
    completion: 85,
    roles: ['rectorate', 'sysadmin', 'methodist', 'dean', 'head_of_department', 'hr_students', 'hr_employees', 'accountant', 'archivist'],
  },
  {
    id: 'integrations',
    title: 'Интеграции',
    description: 'Tunduk, ЕГЭ, ЦОР, антиплагиат, банки, СЭД',
    category: 'admin',
    path: '/admin/integrations/',
    icon: 'package',
    completion: 50,
    roles: ['sysadmin', 'rectorate'],
  },
  {
    id: 'reports-1nk',
    title: 'Отчёт 1-НК',
    description: 'Государственный отчёт для МОиН КР',
    category: 'admin',
    path: '/reports/form-1nk/',
    icon: 'file-text',
    completion: 70,
    roles: ['methodist', 'dean', 'head_of_department', 'rectorate', 'sysadmin'],
  },
  {
    id: 'reports-contingent',
    title: 'Отчёт «Контингент»',
    description: 'Распределение студентов по направлениям и формам',
    category: 'admin',
    path: '/reports/contingent/',
    icon: 'list',
    completion: 75,
    roles: ['methodist', 'dean', 'head_of_department', 'rectorate', 'sysadmin'],
  },
  {
    id: 'reports-accreditation',
    title: 'Отчёт «Аккредитация»',
    description: 'Метрики ECAQA / IAAR',
    category: 'admin',
    path: '/reports/accreditation/',
    icon: 'award',
    completion: 60,
    roles: ['rectorate', 'sysadmin', 'dean'],
  },
  {
    id: 'dean-dashboard',
    title: 'Дашборд факультета',
    description: 'KPI факультета: контингент, средний балл, отсев',
    category: 'admin',
    path: '/dean-dashboard/',
    icon: 'pie',
    completion: 75,
    roles: ['dean', 'rectorate', 'sysadmin'],
  },
  {
    id: 'all-statistic',
    title: 'Общая статистика',
    description: 'Аналитика по всему университету',
    category: 'admin',
    path: '/all-statistic/',
    icon: 'bar',
    completion: 65,
    roles: ['rectorate', 'sysadmin', 'methodist', 'dean', 'head_of_department', 'hr_students', 'hr_employees', 'accountant', 'archivist'],
  },
  {
    id: 'api-docs',
    title: 'API документация',
    description: 'OpenAPI 3.0 schema + Swagger UI',
    category: 'admin',
    path: '/help/api/',
    icon: 'server',
    completion: 80,
    roles: ['sysadmin'],
  },
  {
    id: 'audit-log',
    title: 'Аудит-журнал',
    description: 'Все действия пользователей с IP и timestamp',
    category: 'admin',
    path: '/admin/',
    icon: 'list',
    completion: 70,
    roles: ['rectorate', 'sysadmin'],
  },

  // === Коммуникации ===
  {
    id: 'chats',
    title: 'Чаты',
    description: 'Личные и групповые переписки + WebSocket real-time',
    category: 'communication',
    path: '/chats/',
    icon: 'message-circle',
    completion: 75,
    roles: ['student', 'teacher', 'curator', 'head_of_department', 'dean', 'methodist', 'hr_students', 'hr_employees', 'accountant', 'archivist', 'rectorate', 'sysadmin', 'parent'],
  },
  {
    id: 'notifications',
    title: 'Уведомления',
    description: 'Real-time уведомления через WebSocket с JWT-auth',
    category: 'communication',
    path: '/notifications/',
    icon: 'bell',
    completion: 80,
    roles: ['student', 'teacher', 'curator', 'head_of_department', 'dean', 'methodist', 'hr_students', 'hr_employees', 'accountant', 'archivist', 'rectorate', 'sysadmin', 'parent', 'foreign_student', 'postgrad', 'dpo_student', 'dorm_staff'],
  },
  {
    id: 'tasks',
    title: 'Задачи',
    description: 'Личные задачи и поручения, дерево подзадач',
    category: 'communication',
    path: '/tasks/',
    icon: 'check-square',
    completion: 78,
    roles: ['student', 'teacher', 'curator', 'head_of_department', 'dean', 'methodist', 'hr_students', 'hr_employees', 'accountant', 'archivist', 'rectorate', 'sysadmin'],
  },
  {
    id: 'notes',
    title: 'Заметки',
    description: 'Персональные заметки с тегами и поиском',
    category: 'communication',
    path: '/notes/',
    icon: 'edit-2',
    completion: 75,
    roles: ['student', 'teacher', 'curator', 'head_of_department', 'dean', 'methodist', 'hr_students', 'hr_employees', 'accountant', 'archivist', 'rectorate', 'sysadmin'],
  },
  {
    id: 'calendar',
    title: 'Календарь',
    description: 'Личный календарь + университетский календарь событий',
    category: 'communication',
    path: '/calendar/',
    icon: 'calendar',
    completion: 70,
    roles: ['student', 'teacher', 'curator', 'head_of_department', 'dean', 'methodist', 'hr_students', 'hr_employees', 'accountant', 'archivist', 'rectorate', 'sysadmin'],
  },
  {
    id: 'help',
    title: 'Помощь',
    description: 'FAQ, инструкции, контакты поддержки',
    category: 'communication',
    path: '/help/',
    icon: 'help-circle',
    completion: 75,
    roles: ['student', 'teacher', 'curator', 'head_of_department', 'dean', 'methodist', 'hr_students', 'hr_employees', 'accountant', 'archivist', 'rectorate', 'sysadmin', 'parent', 'foreign_student', 'postgrad', 'dpo_student', 'applicant'],
  },

  // === Дополнительные ===
  {
    id: 'personal-card',
    title: 'Личная карточка',
    description: 'Профиль, документы, паспорт, образование',
    category: 'extra',
    path: '/personalcard/',
    icon: 'user',
    completion: 85,
    roles: ['student', 'teacher', 'curator', 'head_of_department', 'dean', 'methodist', 'hr_students', 'hr_employees', 'accountant', 'archivist', 'rectorate', 'sysadmin', 'parent', 'foreign_student', 'postgrad', 'dpo_student', 'proctor'],
  },
  {
    id: 'europass',
    title: 'Europass CV',
    description: 'Резюме в европейском формате (ru/en/ky)',
    category: 'extra',
    path: '/europass/',
    icon: 'file-text',
    completion: 80,
    roles: ['student', 'teacher', 'curator', 'head_of_department', 'dean', 'methodist', 'hr_students', 'hr_employees', 'rectorate', 'sysadmin', 'foreign_student', 'postgrad', 'dpo_student'],
  },
  {
    id: 'report-card',
    title: 'Табель',
    description: 'Учёт рабочего времени',
    category: 'extra',
    path: '/report-card/',
    icon: 'gradebook',
    completion: 70,
    roles: ['student', 'teacher', 'curator', 'head_of_department', 'dean', 'methodist', 'hr_students', 'hr_employees', 'accountant', 'archivist', 'rectorate', 'sysadmin'],
  },
  {
    id: '2fa-setup',
    title: '2FA (TOTP)',
    description: 'Двухфакторная аутентификация через Google/MS Authenticator',
    category: 'extra',
    path: '/2fa-setup/',
    icon: 'shield-check',
    completion: 90,
    roles: ['rectorate', 'sysadmin', 'accountant', 'archivist', 'methodist', 'dean', 'head_of_department', 'hr_students', 'hr_employees', 'teacher', 'curator', 'student'],
  },
  {
    id: 'proctoring',
    title: 'Прокторинг',
    description: 'Контроль академической честности на онлайн-экзаменах',
    category: 'extra',
    path: '/take-test/',
    icon: 'shield',
    completion: 55,
    roles: ['student', 'proctor', 'teacher', 'methodist', 'dean'],
  },

  // ───────── Дополнительно: подмодули и интеграционные сервисы ─────────
  {
    id: 'schedule-builder',
    title: 'Конструктор расписания',
    description: 'Drag&Drop пар на сетку, проверка конфликтов аудиторий и преподавателей',
    category: 'academic',
    path: '/schedule-builder/',
    icon: 'calendar-plus',
    completion: 80,
    roles: ['methodist', 'dean', 'head_of_department', 'rectorate', 'sysadmin'],
  },
  {
    id: 'schedule-import',
    title: 'Импорт расписания',
    description: 'Загрузка XLSX/CSV-расписания с валидацией и матчингом',
    category: 'academic',
    path: '/schedule-import/',
    icon: 'cloud-upload',
    completion: 60,
    roles: ['methodist', 'dean', 'head_of_department', 'rectorate', 'sysadmin'],
  },
  {
    id: 'lesson-reschedule',
    title: 'Перенос занятий',
    description: 'Точечный перенос пары с уведомлением группы и преподавателя',
    category: 'academic',
    path: '/lesson-reschedule/',
    icon: 'rotate-cw',
    completion: 55,
    roles: ['methodist', 'dean', 'head_of_department', 'rectorate', 'sysadmin'],
  },
  {
    id: 'syllabus-builder',
    title: 'Конструктор учебного плана',
    description: 'ОПОП: семестры, дисциплины, компетенции, часы',
    category: 'academic',
    path: '/syllabus-builder/',
    icon: 'edit-2',
    completion: 78,
    roles: ['methodist', 'dean', 'rectorate', 'sysadmin'],
  },
  {
    id: 'syllabus-diff',
    title: 'Сравнение версий ОПОП',
    description: 'Diff между версиями учебного плана',
    category: 'academic',
    path: '/syllabus-diff/',
    icon: 'list',
    completion: 65,
    roles: ['methodist', 'dean', 'rectorate', 'sysadmin'],
  },
  {
    id: 'syllabus-approval',
    title: 'Утверждение УП',
    description: 'Согласование учебных планов деканом / ректоратом',
    category: 'academic',
    path: '/syllabus-approval/',
    icon: 'check-square',
    completion: 70,
    roles: ['dean', 'rectorate', 'sysadmin'],
  },
  {
    id: 'absence-justification',
    title: 'Оправдательные документы',
    description: 'Загрузка и рассмотрение справок (медицинские, военкомат и пр.)',
    category: 'academic',
    path: '/absence-justification/',
    icon: 'file-text',
    completion: 70,
    roles: ['student', 'curator', 'dean', 'methodist', 'head_of_department'],
  },

  // ───────── Коммуникации (расширение) ─────────
  {
    id: 'support',
    title: 'Поддержка',
    description: 'Тикеты, чат поддержки, «Срочный инцидент»',
    category: 'communication',
    path: '/help/',
    icon: 'help-circle',
    completion: 50,
    roles: ['student', 'teacher', 'curator', 'head_of_department', 'dean', 'methodist', 'hr_students', 'hr_employees', 'accountant', 'archivist', 'rectorate', 'sysadmin', 'parent', 'foreign_student', 'postgrad', 'dpo_student', 'applicant', 'dorm_staff', 'proctor'],
  },
  {
    id: 'news',
    title: 'Новости',
    description: 'Корпоративные новости и анонсы',
    category: 'communication',
    path: '/home/',
    icon: 'flag',
    completion: 65,
    roles: ['student', 'teacher', 'curator', 'head_of_department', 'dean', 'methodist', 'hr_students', 'hr_employees', 'accountant', 'archivist', 'rectorate', 'sysadmin', 'parent', 'foreign_student', 'postgrad', 'dpo_student', 'dorm_staff', 'proctor'],
  },
  {
    id: 'alerts',
    title: 'Системные алерты',
    description: 'Real-time уведомления о критических событиях через WebSocket',
    category: 'communication',
    path: '/home/',
    icon: 'alert-circle',
    completion: 75,
    roles: ['student', 'teacher', 'curator', 'head_of_department', 'dean', 'methodist', 'hr_students', 'hr_employees', 'accountant', 'archivist', 'rectorate', 'sysadmin', 'foreign_student', 'postgrad', 'dpo_student'],
  },

  // ───────── Дополнительные модули ─────────
  {
    id: 'projects',
    title: 'Проекты',
    description: 'Внутренние корпоративные проекты, команды, артефакты',
    category: 'extra',
    path: '/structure/',
    icon: 'briefcase',
    completion: 40,
    roles: ['teacher', 'head_of_department', 'dean', 'methodist', 'rectorate', 'sysadmin'],
  },
  {
    id: 'wallpaper',
    title: 'Фоновые темы',
    description: 'Кастомизация фонового изображения личного кабинета',
    category: 'extra',
    path: '/personalcard/',
    icon: 'image',
    completion: 60,
    roles: ['student', 'teacher', 'curator', 'head_of_department', 'dean', 'methodist', 'hr_students', 'hr_employees', 'accountant', 'archivist', 'rectorate', 'sysadmin', 'parent', 'foreign_student', 'postgrad', 'dpo_student', 'dorm_staff', 'proctor'],
  },
  {
    id: 'organizations',
    title: 'Организации (контрагенты)',
    description: 'Реестр внешних организаций (партнёры по практике, НИР, ДПО)',
    category: 'admin',
    path: '/admin_organizations/',
    icon: 'building',
    completion: 55,
    roles: ['rectorate', 'sysadmin', 'methodist', 'dean', 'hr_employees'],
  },
  {
    id: 'add-structure',
    title: 'Создание оргструктуры',
    description: 'Управления, отделы, кафедры, должности',
    category: 'admin',
    path: '/add-structure/',
    icon: 'layers',
    completion: 70,
    roles: ['rectorate', 'sysadmin', 'methodist', 'dean', 'head_of_department', 'hr_employees'],
  },
  {
    id: 'health',
    title: 'Health-check API',
    description: 'Проверка работоспособности backend-сервисов (`/api/health/`)',
    category: 'admin',
    path: '/help/api/',
    icon: 'activity',
    completion: 90,
    roles: ['sysadmin'],
  },
  {
    id: 'audit-actions',
    title: 'Аудит действий',
    description: 'Журнал всех системных действий с IP, ролью и timestamp',
    category: 'admin',
    path: '/admin/',
    icon: 'list',
    completion: 70,
    roles: ['rectorate', 'sysadmin'],
  },
  {
    id: 'role-management',
    title: 'Управление ролями',
    description: 'Создание системных ролей, выдача/отзыв, привязка к правам',
    category: 'admin',
    path: '/admin/',
    icon: 'shield-check',
    completion: 80,
    roles: ['rectorate', 'sysadmin'],
  },
  {
    id: 'user-management',
    title: 'Управление пользователями',
    description: 'Блокировка, разблокировка, сброс пароля и ПИНа',
    category: 'admin',
    path: '/admin/',
    icon: 'users',
    completion: 85,
    roles: ['rectorate', 'sysadmin', 'hr_students', 'hr_employees'],
  },
  {
    id: 'register-person',
    title: 'Регистрация сотрудника',
    description: 'Быстрая форма регистрации (без полного мастера найма)',
    category: 'employees',
    path: '/register_person/',
    icon: 'user-plus',
    completion: 70,
    roles: ['hr_employees', 'rectorate', 'sysadmin'],
  },
]

// Список всех ролей с человекочитаемыми названиями.
export const ROLE_LABELS = {
  student: 'Студент',
  teacher: 'Преподаватель',
  curator: 'Куратор',
  head_of_department: 'Зав. кафедрой',
  dean: 'Декан',
  methodist: 'Методист',
  hr_students: 'ОК-Студенты',
  hr_employees: 'ОК-Сотрудники',
  accountant: 'Бухгалтер',
  archivist: 'Архивист',
  rectorate: 'Ректорат',
  sysadmin: 'Сисадмин',
  parent: 'Родитель',
  applicant: 'Абитуриент',
  foreign_student: 'Иностр. студент',
  postgrad: 'Магистрант/аспирант',
  dpo_student: 'Слушатель ДПО',
  dorm_staff: 'Сотрудник общежития',
  proctor: 'Проктор',
}

export function getCompletionColor(pct) {
  if (pct >= 80) return '#10b981' // green
  if (pct >= 60) return '#f59e0b' // amber
  if (pct >= 30) return '#fb923c' // orange
  return '#ef4444' // red
}

export function getOverallCompletion() {
  const sum = SERVICES.reduce((acc, s) => acc + s.completion, 0)
  return Math.round(sum / SERVICES.length)
}
